<script setup lang="ts">
import { RouterLink } from 'vue-router'
import { PhInstagramLogo } from '@phosphor-icons/vue'
import { brandWordmarkUrl, footerNav, siteNav } from '@/data/ecosystem'

const year = new Date().getFullYear()
</script>

<template>
  <footer class="border-t border-border/60 bg-muted/35">
    <div class="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8">
      <div class="grid gap-12 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div class="space-y-4 sm:col-span-2 lg:col-span-1">
          <RouterLink to="/" aria-label="As-Safwah home" class="inline-flex">
            <img
              :src="brandWordmarkUrl"
              alt="As-Safwah Inc."
              class="h-12 w-auto object-contain sm:h-14"
              width="220"
              height="56"
            />
          </RouterLink>
          <p class="max-w-xs text-sm leading-relaxed text-muted-foreground">
            Faith-rooted parent company for Muslim brands. Guided by Quran and Sunnah.
          </p>
          <a
            href="https://www.instagram.com/assafwahinc/"
            target="_blank"
            rel="noreferrer"
            aria-label="As-Safwah Inc. on Instagram"
            class="inline-flex h-10 w-10 items-center justify-center rounded-full text-secondary transition-all duration-300 hover:bg-secondary/10 hover:scale-110"
          >
            <PhInstagramLogo :size="24" weight="fill" />
          </a>
        </div>

        <div>
          <p class="text-sm font-semibold text-foreground">Explore</p>
          <ul class="mt-4 space-y-2.5 text-sm text-muted-foreground">
            <li v-for="item in siteNav" :key="item.to">
              <RouterLink :to="item.to" class="footer-link">{{ item.label }}</RouterLink>
            </li>
          </ul>
        </div>

        <div>
          <p class="text-sm font-semibold text-foreground">Connect</p>
          <ul class="mt-4 space-y-2.5 text-sm text-muted-foreground">
            <li v-for="item in footerNav" :key="item.to">
              <RouterLink :to="item.to" class="footer-link">{{ item.label }}</RouterLink>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="mt-14 flex flex-col gap-2 border-t border-border/60 pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between"
      >
        <p>&copy; {{ year }} As-Safwah Inc. All rights reserved.</p>
        <p>Guided by Quran and Sunnah.</p>
      </div>
    </div>
  </footer>
</template>
